
/* === modal.js === */
if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.boundKeyDown = this.handleKeyDown.bind(this);
      this.boundTriggerClick = this.handleTriggerClick.bind(this);
      this.boundFocusTrap = this.handleFocusTrap.bind(this);
    }

    connectedCallback() {
      this.wrapper = this;
      this.modalContainer = this.querySelector('.modal');
      this.overlay = this.querySelector('[data-modal-overlay]');
      this.closeBtn = this.querySelector('[data-modal-close]');
      this.content = this.querySelector('[data-modal-body]');

      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      document.addEventListener('click', this.boundTriggerClick);
      document.addEventListener('keydown', this.boundKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundTriggerClick);
      document.removeEventListener('keydown', this.boundKeyDown);
    }

    handleTriggerClick(e) {
      const trigger = e.target.closest('[data-modal-open]');
      if (!trigger) return;
      e.preventDefault();
      this.open(null, trigger.dataset.modalOpen);
    }

    handleKeyDown(e) {
      if (!this.isOpen()) return;
      if (e.key === 'Escape') {
        this.close();
      } else if (e.key === 'Tab') {
        this.handleFocusTrap(e);
      }
    }

    handleFocusTrap(e) {
      const focusableElements = this.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }

    open(contentHtml = null, contentId = null) {
      if (contentHtml) {
        this.content.innerHTML = contentHtml;
      } else if (contentId) {
        const template = document.querySelector(`[data-modal-content="${contentId}"]`);
        if (template) {
          this.content.innerHTML = template.innerHTML;
        } else {
          console.warn(`[Modal] Template not found: ${contentId}`);
          return;
        }
      }

      this.wrapper.classList.remove('hidden');
      this.wrapper.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');

      if (this.modalContainer) {
        this.modalContainer.setAttribute('tabindex', '-1');
        this.modalContainer.focus();
      }

      this.dispatchEvent(new CustomEvent('modal:open', {
        bubbles: true,
        detail: { contentId }
      }));
    }

    close() {
      this.wrapper.classList.add('hidden');
      this.wrapper.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');

      if (this.content) {
        this.content.innerHTML = '';
      }

      this.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));
    }

    isOpen() {
      return !this.wrapper.classList.contains('hidden');
    }
  });
}

window.openModal = (contentId, contentHtml = null) => {
  const modal = document.querySelector('modal-dialog[data-modal-id="global-modal"]');
  if (modal) {
    modal.open(contentHtml, contentId);
  }
};

window.closeModal = () => {
  const modal = document.querySelector('modal-dialog[data-modal-id="global-modal"]');
  if (modal) {
    modal.close();
  }
};

